import styled from "styled-components"

function FloorPlate({ planType, ...rest }) {
  const props = {
    strokeOpacity: 0.2,
    stroke: "var(--secondary)",
    strokeMiterlimit: "10",
    strokeWidth: ".5",
  }
  const unactiveOpacity = 0.6
  const activeFill = "var(--accent)"
  const unactiveFill = "white"

  return (
    <FloorPlateWrapper viewBox="0 0 200 200" {...rest}>
      {["I", "J", "K"].includes(planType) ? (
        <g id="I-J-K">
          <path
            id="K"
            d="M54.1,130.9v-57H2.8v76.2c0,8.7,7,15.8,15.7,15.8h35.6v-13.1h4.4v-22h-4.4,0Z"
            fillOpacity={planType === "K" ? 1 : unactiveOpacity}
            fill={planType === "K" ? activeFill : unactiveFill}
            {...props}
          />
          <polygon
            id="J"
            points="97 117.9 97 124.9 70.8 124.9 70.8 117.9 54.1 117.9 54.1 130.8 58.5 130.8 58.5 152.8 54.1 152.8 54.1 165.9 110.4 165.9 110.4 136.3 114.2 136.3 114.2 118 97 118 97 117.9"
            fillOpacity={planType === "J" ? 1 : unactiveOpacity}
            fill={planType === "J" ? activeFill : unactiveFill}
            {...props}
          />
          <polygon
            id="I"
            points="167 117.9 167 165.9 127.7 165.9 110.5 165.9 110.5 136.2 114.3 136.2 114.3 117.9 167 117.9"
            fillOpacity={planType === "I" ? 1 : unactiveOpacity}
            fill={planType === "I" ? activeFill : unactiveFill}
            {...props}
          />
          <path
            id="A"
            d="M127.1,22.4v42.9h7.9v24.6h13.4v-18.4h47.2v-28c0-11.6-9.4-21.1-21.1-21.1h-47.4Z"
            fillOpacity={planType === "A" ? 1 : unactiveOpacity}
            fill={planType === "A" ? activeFill : unactiveFill}
            {...props}
          />
          <path
            id="B-C"
            d="M195.5,71.5v74.5c0,10.9-8.8,19.7-19.7,19.7h-8.9v-47.8h-22.6v-19.1h4.1v-27.3h47.2,0Z"
            fillOpacity={planType === "B" || planType === "C" ? 1 : unactiveOpacity}
            fill={
              planType === "B" || planType === "C" ? activeFill : unactiveFill
            }
            {...props}
          />
          <path
            id="H"
            d="M127.1,22.4v42.9h-62v19.1h-10.8v-10.5H2.8v1.1c0-4,1.8-7.7,5-10.1L47.5,28.1c4.7-3.7,10.5-5.7,16.5-5.7h63Z"
            fillOpacity={planType === "H" ? 1 : unactiveOpacity}
            fill={planType === "H" ? activeFill : unactiveFill}
            {...props}
          />
        </g>
      ) : (
        <g id="REST">
          <path
            id="A"
            d="M127.1,22.4v42.9h7.9v24.6h13.4v-18.4h47.2v-28c0-11.6-9.4-21.1-21.1-21.1h-47.4Z"
            fillOpacity={planType === "A" ? 1 : unactiveOpacity}
            fill={planType === "A" ? activeFill : unactiveFill}
            {...props}
          />
          <path
            id="B-C"
            d="M195.5,71.5v74.5c0,10.9-8.8,19.7-19.7,19.7h-8.9v-47.8h-22.6v-19.1h4.1v-27.3h47.2,0Z"
            fillOpacity={planType === "B" || planType === "C" ? 1 : unactiveOpacity}
            fill={
              planType === "B" || planType === "C" ? activeFill : unactiveFill
            }
            {...props}
          />
          <rect
            id="D"
            x="127.8"
            y="117.9"
            width="39.1"
            height="47.8"
            fillOpacity={planType === "D" ? 1 : unactiveOpacity}
            fill={planType === "D" ? activeFill : unactiveFill}
            {...props}
          />
          <polygon
            id="E"
            points="127.8 117.9 127.8 165.7 72.7 165.7 72.7 137.7 83.9 137.7 83.9 124.9 97.1 124.9 97.1 117.9 127.8 117.9"
            fillOpacity={planType === "E" ? 1 : unactiveOpacity}
            fill={planType === "E" ? activeFill : unactiveFill}
            {...props}
          />
          <path
            id="F"
            d="M83.9,124.9v12.8h-11.1v28H18.6c-8.7,0-15.7-7.1-15.7-15.7v-38.1h27.1v9.5h17.5v-3.5h23.6v7h12.9Z"
            fillOpacity={planType === "F" ? 1 : unactiveOpacity}
            fill={planType === "F" ? activeFill : unactiveFill}
            {...props}
          />
          <polygon
            id="G"
            points="2.8 111.9 2.8 74 54.2 74 54.2 117.9 47.4 117.9 47.4 121.4 29.9 121.4 29.9 111.9 2.8 111.9"
            fillOpacity={planType === "G" ? 1 : unactiveOpacity}
            fill={planType === "G" ? activeFill : unactiveFill}
            {...props}
          />
          <path
            id="H"
            d="M127.1,22.4v42.9h-62v19.1h-10.8v-10.5H2.8v1.1c0-4,1.8-7.7,5-10.1L47.5,28.1c4.7-3.7,10.5-5.7,16.5-5.7h63Z"
            fillOpacity={planType === "H" ? 1 : unactiveOpacity}
            fill={planType === "H" ? activeFill : unactiveFill}
            {...props}
          />
        </g>
      )}
    </FloorPlateWrapper>
  )
}

export default FloorPlate

const FloorPlateWrapper = styled.svg``
